import { gql } from 'graphql-tag'

//Atualidades
export const createActivity = gql`
  mutation createActivity($title: String!) {
    createActivity(title: $title) {
      id
      title
      moduleId
    }
  }
`

export const createAtualidadesActivity = gql`
  mutation createAtualidadesActivity($title: String!) {
    createAtualidadesActivity(title: $title) {
      id
      title
      moduleId
    }
  }
`

export const addBookToAtualidadesActivity = gql`
  mutation addBookToAtualidadesActivity($activityId: Int!, $slug: String!) {
    addBookToAtualidadesActivity(activityId: $activityId, slug: $slug) {
      id
      moduleId
      books {
        name
      }
    }
  }
`

export const removeBookFromAtualidadesActivity = gql`
  mutation removeBookFromAtualidadesActivity(
    $activityId: Int!
    $slug: String!
  ) {
    removeBookFromAtualidadesActivity(activityId: $activityId, slug: $slug) {
      id
      moduleId
      books {
        name
      }
    }
  }
`

export const applyIndependentActivityToReader = gql`
  mutation applyIndependentActivityToReader($activityId: Int!) {
    applyIndependentActivityToReader(activityId: $activityId) {
      activity {
        moduleId
      }
      id
    }
  }
`

export const addArticleToActivity = gql`
  mutation addArticleToActivity($articleId: Int!, $activityId: Int!) {
    addArticleToActivity(articleId: $articleId, activityId: $activityId) {
      article {
        title
      }
      activity {
        title
      }
    }
  }
`

export const setActivityDegreeRange = gql`
  mutation setActivityDegreeRange($activityId: Int!, $degreeRange: [String!]) {
    setActivityDegreeRange(activityId: $activityId, degreeRange: $degreeRange) {
      id
    }
  }
`

export const createExamQuestion = gql`
  mutation createExamQuestion(
    $activityId: Int!
    $examQuestionType: ExamQuestionType!
    $pageReference: String
    $relatedBnccs: [Int]
  ) {
    createExamQuestion(
      activityId: $activityId
      examQuestionType: $examQuestionType
      pageReference: $pageReference
      relatedBnccs: $relatedBnccs
    ) {
      id
    }
  }
`

export const setExamQuestionStatement = gql`
  mutation setExamQuestionStatement(
    $activityId: Int!
    $examQuestionId: Int!
    $statement: String!
    $expectedAnswer: String
  ) {
    setExamQuestionStatement(
      activityId: $activityId
      examQuestionId: $examQuestionId
      statement: $statement
      expectedAnswer: $expectedAnswer
    ) {
      id
    }
  }
`

export const addChoiceToExamQuestion = gql`
  mutation addChoiceToExamQuestion(
    $examQuestionId: Int!
    $isCorrect: Boolean!
    $statement: String!
  ) {
    addChoiceToExamQuestion(
      examQuestionId: $examQuestionId
      isCorrect: $isCorrect
      statement: $statement
    ) {
      id
    }
  }
`

export const setChoiceStatement = gql`
  mutation setChoiceStatement(
    $activityId: Int!
    $examQuestionChoiceId: Int!
    $statement: String!
  ) {
    setChoiceStatement(
      activityId: $activityId
      examQuestionChoiceId: $examQuestionChoiceId
      statement: $statement
    ) {
      id
    }
  }
`

// Sentir

export const createSentirActivity = gql`
  mutation createSentirActivity($title: String!) {
    createSentirActivity(title: $title) {
      id
      title
      moduleId
    }
  }
`

// Avaliação Leitora
export enum IdentifyMotrixUserErrors {
  internalServerError = 'motrix_api_unavailable',
  cannotUploadAudio = 'motrix_upload_audio_error',
  wrongParameterWhenCreateRecordingId = 'motrix_create_new_recording_error'
}

export const identifyMotrixUser = gql`
  mutation identifyMotrixUser($degree: String!, $entityName: String!) {
    identifyMotrixUser(degree: $degree, entityName: $entityName) {
      partnerData
      partnerExternalId
      partnerId
      userId
    }
  }
`

export const createNewMotrixRecording = gql`
  mutation createNewMotrixRecording($partnerExternalId: String!) {
    createNewMotrixRecording(partnerExternalId: $partnerExternalId) {
      recordingId
      imageCategory
      imagePath
      sessionId
    }
  }
`

export const createOnboardingReaderThemes = gql`
  mutation createOnboardingReaderThemes(
    $onboardingReaderProfileThemes: [OnboardingReaderProfileThemesInput!]
  ) {
    createOnboardingReaderThemes(
      onboardingReaderProfileThemes: $onboardingReaderProfileThemes
    ) {
      entities {
        onboardingReaderProfileThemeId
      }
    }
  }
`

export const updateOnboardingTutorialState = gql`
  mutation updateOnboardingV2TutorialState($action: TutorialActions!) {
    updateOnboardingV2TutorialState(action: $action) {
      id
      userId
      interactions
      name
      state
    }
  }
`

export const updateGamificationOnboardingTutorialState = gql`
  mutation updateGamificationOnboardingTutorialState(
    $action: TutorialActions!
  ) {
    updateGamificationOnboardingTutorialState(action: $action) {
      id
      userId
      interactions
      name
      state
      updatedAt
    }
  }
`

export const updateAdminPanelV2OnboardingTutorialState = gql`
  mutation updateAdminPanelV2OnboardingTutorialState(
    $action: TutorialActions!
  ) {
    updateAdminPanelV2OnboardingTutorialState(action: $action) {
      id
      userId
      interactions
      name
      state
      updatedAt
    }
  }
`

export const assignOnboardingLikedBooksToReaderInput = gql`
  mutation assignOnboardingLikedBooksToReader(
    $likedBooks: [AssignOnboardingLikedBooksToReaderInput!]
  ) {
    assignOnboardingLikedBooksToReader(likedBooks: $likedBooks) {
      likedBooks {
        slug
        liked
      }
    }
  }
`

export const removeOnboardingThemesFromReader = gql`
  mutation removeOnboardingThemesFromReader {
    removeOnboardingThemesFromReader {
      message
      errors
    }
  }
`

export const unassignOnboardingLikedBooks = gql`
  mutation unassignOnboardingLikedBooks {
    unassignOnboardingLikedBooks {
      message
    }
  }
`

// Diario de Emocoes

export const EmotionsJournalCreateEmotionEntry = gql`
  mutation createEmotionJournalEntry(
    $primaryEmotion: JournalPrimaryEmotion!
    $note: String
    $blockNote: Boolean
    $secondaryEmotions: [JournalSecondaryEmotion]
  ) {
    createEmotionJournalEntry(
      input: {
        primaryEmotion: $primaryEmotion
        note: $note
        blockNote: $blockNote
        secondaryEmotions: $secondaryEmotions
      }
    ) {
      id
      primaryEmotion
      note
      blockNote
      secondaryEmotions {
        slug
      }
      insertedAt
    }
  }
`

export const updateNotificationPreferences = gql`
  mutation updateNotificationPreferences($notificationType: NotificationType!) {
    toggleNotificationStatus(input: { notificationType: $notificationType }) {
      weeklyReadingReport
    }
  }
`

// Atividades

export const adminDeleteActivity = gql`
  mutation adminDeleteActivity($activityId: Int!) {
    adminDeleteActivity(activityId: $activityId) {
      id
    }
  }
`

export const createActivityV2 = gql`
  mutation createActivityV2(
    $activityQuestions: [CreateExamQuestionInput]
    $module: ModuleType!
    $relatedArticles: [Int]
    $relatedBooks: [String]
    $submitPublicApproval: Boolean!
    $suggestedDegrees: [ActivityDegree]!
    $title: String!
  ) {
    createActivityV2(
      input: {
        activityQuestions: $activityQuestions
        module: $module
        relatedArticles: $relatedArticles
        relatedBooks: $relatedBooks
        submitPublicApproval: $submitPublicApproval
        suggestedDegrees: $suggestedDegrees
        title: $title
      }
    ) {
      id
      title
      moduleId
      articles {
        id
      }
      books {
        name
        degree
      }
      examQuestions {
        id
        statement
        type
        examQuestionChoices {
          statement
          isCorrect
        }
      }
    }
  }
`

export const editActivity = gql`
  mutation editActivity(
    $activityId: Int!
    $activityQuestions: [EditExamQuestionInput]
    $module: ModuleType!
    $relatedArticles: [Int]
    $relatedBooks: [String]
    $submitPublicApproval: Boolean!
    $suggestedDegrees: [ActivityDegree]
    $title: String!
  ) {
    editActivity(
      input: {
        activityId: $activityId
        activityQuestions: $activityQuestions
        module: $module
        relatedArticles: $relatedArticles
        relatedBooks: $relatedBooks
        submitPublicApproval: $submitPublicApproval
        suggestedDegrees: $suggestedDegrees
        title: $title
      }
    ) {
      id
      title
      moduleId
      articles {
        id
      }
      books {
        name
        degree
        slug
      }
      examQuestions {
        id
        statement
        type
        examQuestionChoices {
          statement
          isCorrect
        }
      }
    }
  }
`

//indication mutations
export const createContentIndications = gql`
  mutation CreateContentIndications($input: CreateContentIndicationInput!) {
    createContentIndications(input: $input) {
      sourceUser {
        id
        name
        isTeacher
      }
      target {
        id
        type
      }
      content {
        identifier
        type
      }
      dueDate
      indicatedAt
    }
  }
`

export const removeContentIndicationMutation = gql`
  mutation removeContentIndication($indicationId: Int!) {
    removeContentIndication(contentIndicationId: $indicationId) {
      id
    }
  }
`

export const consumeContent = gql`
  mutation ConsumeContent($input: ConsumeContentInput!) {
    consumeContent(input: $input) {
      rewards {
        type
        amount
      }
    }
  }
`

export const sendFeatureFeedback = gql`
  mutation sendFeatureFeedback($feedback: String!) {
    sendFeatureFeedback(feedback: $feedback)
  }
`
